// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__SnC4g","icon":"SortAdornment_icon__2Qc3m","up":"SortAdornment_up__e_Fv1","down":"SortAdornment_down__3ujC6","active":"SortAdornment_active__1VwwN"};